export enum DASHBOARDS {
    STATUS = 'status',
    EXPLORE = 'explore',
    EXPLORE_ASSET = 'explore asset',
    ALERTS = 'alerts',
    DASHBOARDS = 'dashboards',
    SENSOR = 'sensor',
    UTILIZATION = 'utilization',
    SMART_REPORTS = 'reports',
    COST = 'cost',
    MANAGEMENT = 'management',
}
